import { defineNuxtPlugin } from '#app'

import { useUserStore } from '~/stores/user'
import { useWorkspaceStore } from '~/stores/workspace'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();

    const userStore = useUserStore()
    const workspaceStore = useWorkspaceStore()

    const user = computed(() => userStore.user)
    const workspace = computed(() => workspaceStore.currentWorkspace)

    // check environment
    if (config.public.env === 'development' || !config.public.pipebackId) return

    (window as any).$pipeback = [];
    (window as any).PIPEBACK_ID = config.public.pipebackId;

    (function () {
        const d = document;
        const s = d.createElement("script");
        s.src = "https://widget.pipeback.com/l.js";
        s.async = true;
        d.getElementsByTagName("head")[0].appendChild(s);
    })();

    (window as any).$pipeback = {
        user: {
            id: user.value?.id,
            name: user.value?.name,
            email: user.value?.email,
            signature: user.value?.pipeback_messenger_user_hash, // needs to come from backend
            company: {
                id: workspace.value?.id,
                name: workspace.value?.name,
                website: workspace.value?.domain,
            },
        },
    };

    return {
        provide: {
            pipeback: (window as any).$pipeback
        }
    }
})